import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import type { SlideState, VerseData } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

@customElement("bp-verse-comparison-slide")
export class VerseComparisonSlide extends LitElement {
  static styles = css`
    .multi-verse-container {
      display: flex;
      flex-direction: column;
      gap: var(--size-2);
    }

    .verse-header {
      font-weight: var(--font-weight-semibold);
    }

    sup {
      color: var(--color-black);
      font-size: var(--font-size-xl);
      vertical-align: 9px;
      font-weight: var(--font-weight-semibold);
    }
  `;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  @property()
  slideState?: SlideState;

  @property({ attribute: "title" })
  slideTitle?: string;

  @property()
  multiVerseData?: Array<VerseData>;

  render() {
    if (!this.multiVerseData) return null;
    return html`
      <bp-scrollable-slide
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">${unsafeHTML(this.slideTitle)}</div>
        <div slot="content" class="multi-verse-container">
          ${this.multiVerseData.map(
            (verseData) => html`
              <div data-id="${verseData.translation}">
                <div class="verse-header">${verseData.translation}</div>
                <div class="verse-content">${unsafeHTML(verseData.text)}</div>
              </div>
            `,
          )}
        </div>
      </bp-scrollable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-verse-comparison-slide": VerseComparisonSlide;
  }
}
